import axios from 'axios';

const API_BASE_URL = 'https://backend.gouniquejourneys.co.uk/api'; // Adjust if needed


export const getContacts = async (  page, limit, sortOrder ) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/contact-us`, {

      params: {  page, limit, sortOrder }, // Send filters as query params
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching contacts:", error.response?.data || error.message);
    throw error;
  }
};
